<template>
    <v-layout justify-space-between row wrap class="white--text">
        <v-flex xs12 class="contato-container" >
            <h2> <strong>Entre em contato </strong>  </h2>
            <div class="risquinho"></div>
        </v-flex>


        <v-flex xs12 class="container-icon">
            <img  class="contato-logo" xs12 :src="logo">
        </v-flex>
        <v-flex class="container-icon" xs12 sm4>
            <v-layout column>
                <v-flex xs12>
                    <img class="icon-bottom" xs12 :src="email"> 

                </v-flex>

                <v-flex xs12>
                    <strong>contato@peccininealessi.adv.br</strong>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex class="container-icon"  xs12 sm4>
            <v-layout column>
                <v-flex xs12>
                    <img class="icon-bottom" :src="phone"> 
                </v-flex>

                <v-flex xs12>
                    <strong>+55 (41) 99522-2650/3528-0402</strong>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex class="container-icon" xs12 sm4>
            <v-layout column>
                <v-flex xs12>
                    <img class="icon-bottom" :src="oab">
                </v-flex>

                <v-flex xs12>
                    <strong>OAB/PR: 9.201</strong>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex class="container-icon" xs12 sm4>
            <v-layout column>
                <v-flex xs12>
                    <a target="_blank" href="https://www.facebook.com/peccininealessi"><img class="icon-bottom" :src="face"></a>
                </v-flex>

                <v-flex xs12>
                    <strong>fb.com/peccininealessi </strong>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex class="container-icon" xs12 sm4>
            <v-layout column>
                <v-flex xs12>
                    <a target="_blank" href="https://www.instagram.com/peccininealessi/"><img class="icon-bottom" :src="insta"></a>
                </v-flex>

                <v-flex xs12>
                    <strong>@peccininealessi</strong>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex class="container-icon" xs12 sm4>
            <v-layout column>
                <v-flex xs12>
                    <a target="_blank" href="https://www.linkedin.com/company/peccininealessi"><img class="icon-bottom" :src="linkedin"></a>
                </v-flex>

                <v-flex xs12>
                    <strong>Peccinin & Alessi Advocacia</strong>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex class="endereco-container" xs12 sm4>
            <strong>R. Heitor Stockler de França, 396, Sala 2406, Centro Cívico, Curitiba, Paraná, CEP 80030-030</strong>
        </v-flex>


    </v-layout>
</template>

<script>
import phone from '../assets/phone.png'
import linkedin from '../assets/linkedin.png'
import email from '../assets/email.png'
import oab from '../assets/oab.png'
import face from '../assets/face.png'
import insta from '../assets/insta.png'
import logo from '../assets/logobranca.png'


export default {
    data () {
        return {
            phone,
            linkedin,
            email,
            oab,
            face,
            insta,
            logo
        }
    }
}
</script>

<style scoped>
.icon-bottom{
    height: 55px;
    width: 55px;
    margin-bottom: 0px; 
}

.contato-logo{
    height: 250px;
}

.container-icon {
    text-align: center;
    margin-bottom: 36px;
}

.endereco-container {
    text-align: center;
    margin-right: auto;
    margin-left: auto;
    padding-left: 5%;
    padding-right: 5%;
}

.contato-container{
    margin-left: 48px;
    /* margin-bottom: 48px; */
}

</style>
